import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import CustomDropdown from '@components/CustomDropdown';

import { getFilterTextFieldValue } from '@features/filter/static/filterUtil';

import {
	updateTextItemInGlobalFilter,
	updateTextItemMultipleInGlobalFilter
} from '@store/actions/FilterAction';

const DependentDropdown = ({
	placeholder = 'Brand',
	identifier = 'brand',
	isHideChip = false,
	options = [],
	multiple
}) => {
	const [items, setItems] = useState([]);
	const filterData = useSelector((store) => store.filterFieldStore);
	const inputValue = getFilterTextFieldValue(filterData, identifier, identifier);
	const dispatch = useDispatch();

	useEffect(() => {
		setItems(options);
	}, [options.length]);

	const onItemClick = (item, multiSelect) => {
		if (multiSelect && Array.isArray(item)) {
			const data = {
				name: identifier,
				list: [
					...(filterData[identifier] || []),
					...item.map((singleItem) => ({
						name: identifier,
						type: 'text',
						key: singleItem.id,
						value: singleItem.value,
						identifier: identifier,
						isHideChip
					}))
				]
			};
			data.list = data.list.filter(
				(obj, index, self) => index === self.findIndex((t) => t.key === obj.key)
			);

			dispatch(updateTextItemMultipleInGlobalFilter(data));
		} else {
			let data = {
				name: identifier,
				type: 'text',
				key: item.id,
				value: item.value,
				identifier: identifier,
				isHideChip
			};
			dispatch(updateTextItemInGlobalFilter(data));
		}
	};

	return (
		<CustomDropdown
			type="addItem"
			title={placeholder}
			isShowLabel={false}
			onItemClick={onItemClick}
			items={items}
			selectedItem={inputValue?.value || placeholder}
			multiple={multiple}
			identifier={identifier}
		/>
	);
};

export default DependentDropdown;
